import { PicItem } from '@containers/Consignments/components/fragments/PICSearch2';
import { IPerson, KeyValuePair } from '@typings';

/**
 * Converts raw Airtable PIC type strings into key-value pairs.
 * Example: "SA-Stock-Agent" -> { key: "SA", value: "Stock-Agent" }
 */
export const convertPicTypeStringsToKeyValuePairs = (picTypeStrings: string[]): KeyValuePair[] => {
    if (!picTypeStrings || picTypeStrings.length === 0) {
        return [];
    }

    return picTypeStrings.map((picTypeString) => {
        const parts = picTypeString.split('-');
        if (parts.length >= 2) {
            return {
                key: parts[0],
                value: parts.slice(1).join('-'),
            };
        } else {
            return {
                key: picTypeString,
                value: picTypeString,
            };
        }
    });
};

export const mapToIPerson = (pic: string, allData: PicItem[]): IPerson => {
    const item = allData.find((x) => x.pic === pic);
    if (!item) {
        return {
            firstName: '',
            lastName: '',
            businessName: '',
            locationTown: '',
            locationState: '',
            locationPostcode: '',
            pic: pic === 'MANUAL' ? '' : pic,
            picType: '',
            manual: '',
        };
    }
    return {
        pic,
        picType: item.picType || '',
        firstName: item.firstName || '',
        lastName: item.lastName || '',
        businessName:
            item.businessName ||
            (item.firstName || item.lastName ? `${item.firstName ?? ''} ${item.lastName ?? ''}`.trim() : undefined),
        locationTown: item.town || '',
        locationState: item.state?.toUpperCase() || '',
        locationAddress: item.address || '',
        locationPostcode: item.postcode || '',
    };
};
